import angular from 'angular';

// Create the module where our functionality can attach to
let servicesModule = angular.module('parkingformApp.services', []);

import ApplicationsService from './applications.service';
servicesModule.service('Applications', ApplicationsService);

import SettingsService from './settings.service';
servicesModule.service('Settings', SettingsService);

import CarsService from './cars.service';
servicesModule.service('Cars', CarsService);

import UsersService from './users.service';
servicesModule.service('Users', UsersService);

import ModalController from '../modal/modal.controller';
servicesModule.controller('ModalController', ModalController);

import ModalService from '../modal/modal.service';
servicesModule.service('Modal', ModalService);

import FakeService from './fake.service';
servicesModule.service('Fake', FakeService);

export default servicesModule;



// WEBPACK FOOTER //
// ./client/components/services/index.js